import { EnvironmentSchema } from '../app/core/models/environment-schema';

export const environment: EnvironmentSchema = {
  production: '#PRODUCTION',
  appVersion: '#APP_VERSION',
  apiBasePath: '#API_BASE_PATH',
  defaultApplicationLanguage: '#DEFAULT_APPLICATION_LANGUAGE' as 'en' | 'de',
  elsaDashboardServer: '#ELSA_DASHBOARD_SERVER',
  elsaApiServer: '#ELSA_API_SERVER',
  mfsControllerUiUrl: '#MFS_CONTROLLER_UI_URL',
  idRepositoryUiUrl: '#ID_REPOSITORY_UI_URL',
  mftUiUrl: '#MFT_UI_URL',
  kibanaDashboardUrl: '#KIBANA_DASHBOARD_URL',
  useClientSideUserViews: '#USE_CLIENT_SIDE_USER_VIEWS' as unknown as boolean,
  keycloakConfig: {
    url: '#KEYCLOAK_URL',
    realm: '#KEYCLOAK_REALM',
    clientId: '#KEYCLOAK_CLIENT_ID',
  },
  apiConfig: {
    aiAnomalyApiServiceUrl: '#AI_ANOMALY_API_SERVICE_URL',
    elsaManagementApiServiceUrl: '#ELSA_MANAGEMENT_API_SERVICE_URL',
    essenceApiServiceUrl: '#ESSENCE_API_SERVICE_URL',
    idRepositoryApiServiceUrl: '#ID_REPOSITORY_API_SERVICE_URL',
    mfsControllerApiServiceUrl: '#MFS_CONTROLLER_API_SERVICE_URL',
    mftDashboardApiServiceUrl: '#MFT_DASHBOARD_API_SERVICE_URL',
    opsCenterApiServiceUrl: '#OPS_CENTER_API_SERVICE_URL',
    serverEventApiServiceUrl: '#SERVER_EVENT_API_SERVICE_URL',
    userTasksApiServiceUrl: '#USER_TASKS_API_SERVICE_URL',
  },
};
